import TooltipContainer from "../../Componant/Ui Kit/Tooltip";

const Tooltip = () => {
  return (
    <div className="page-body">
      <TooltipContainer />
    </div>
  );
};

export default Tooltip;
